import React, { useState } from 'react';
import axios from 'axios';

// ===================================================================================
// Modernized Registration Page Component
// ===================================================================================
const RegisterPage = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!name || !email || !password || !confirmPassword) {
            setError('All fields are required.');
            return;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        if (password.length < 6) {
            setError('Password must at be at least 6 characters long.');
            return;
        }

        setIsLoading(true);

        try {
            await axios.post(`${API_BASE_URL}/api/auth/register`, {
                name,
                email,
                password,
                role: 'USER',
            });

            setSuccess('Registration successful! Redirecting to login...');
            
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);

        } catch (err) {
            if (err.response && err.response.data) {
                setError(err.response.data.message || 'Registration failed. Please try again.');
            } else {
                setError('An unexpected error occurred. Please check your connection.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="register-container">
            <div className="register-backdrop"></div>
            <div className="register-card">
                <div className="register-header">
                    <div className="register-logo">
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="48" height="48" rx="12" fill="url(#gradient-reg)"/>
                            <path d="M14 24C14 18.477 18.477 14 24 14C29.523 14 34 18.477 34 24" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                            <path d="M20 28C20 24.686 22.686 22 26 22C29.314 22 32 24.686 32 28" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                            <circle cx="24" cy="24" r="3" fill="white"/>
                            <circle cx="26" cy="28" r="2" fill="white"/>
                            <defs>
                                <linearGradient id="gradient-reg" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#10B981"/>
                                    <stop offset="1" stopColor="#059669"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <h1 className="register-title">Create an Account</h1>
                    <p className="register-subtitle">Join our platform today!</p>
                </div>

                <form onSubmit={handleSubmit} className="register-form">
                    {error && (
                        <div className="register-message error">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
                            </svg>
                            {error}
                        </div>
                    )}
                    {success && (
                        <div className="register-message success">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                            </svg>
                            {success}
                        </div>
                    )}
                    
                    <div className="form-group">
                        <label htmlFor="name">Full Name</label>
                        <div className="input-wrapper">
                            <span className="input-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                            </span>
                            <input
                                type="text"
                                id="name"
                                placeholder="Enter your full name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="register-input"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <div className="input-wrapper">
                            <span className="input-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                    <polyline points="22,6 12,13 2,6"></polyline>
                                </svg>
                            </span>
                            <input
                                type="email"
                                id="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="register-input"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="input-wrapper">
                            <span className="input-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                </svg>
                            </span>
                            <input
                                type="password"
                                id="password"
                                placeholder="Create a password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="register-input"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <div className="input-wrapper">
                            <span className="input-icon">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                </svg>
                            </span>
                            <input
                                type="password"
                                id="confirmPassword"
                                placeholder="Confirm your password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="register-input"
                                required
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="register-button"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <span className="register-spinner"></span>
                        ) : (
                            <>
                                Create Account
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="8.5" cy="7" r="4"></circle>
                                    <line x1="20" y1="8" x2="20" y2="14"></line>
                                    <line x1="23" y1="11" x2="17" y2="11"></line>
                                </svg>
                            </>
                        )}
                    </button>
                </form>

                <div className="register-footer">
                    <span>Already have an account?</span>
                    <a href="/login" className="register-link">Sign In</a>
                </div>
            </div>

            <style>{`
                .register-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 100vh;
                    background: #0F1419;
                    position: relative;
                    overflow: hidden;
                }
                
                .register-backdrop {
                    position: absolute;
                    inset: 0;
                    background: 
                        radial-gradient(ellipse at 20% 20%, rgba(16, 185, 129, 0.15) 0%, transparent 50%),
                        radial-gradient(ellipse at 80% 80%, rgba(5, 150, 105, 0.1) 0%, transparent 50%),
                        radial-gradient(ellipse at 50% 50%, rgba(16, 185, 129, 0.05) 0%, transparent 70%);
                }
                
                .register-card {
                    position: relative;
                    width: 100%;
                    max-width: 440px;
                    padding: 40px;
                    background: rgba(30, 37, 54, 0.8);
                    backdrop-filter: blur(20px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 24px;
                    box-shadow: 
                        0 25px 50px -12px rgba(0, 0, 0, 0.5),
                        0 0 0 1px rgba(255, 255, 255, 0.05) inset;
                    animation: slideUp 0.5s ease-out;
                }
                
                .register-header {
                    text-align: center;
                    margin-bottom: 32px;
                }
                
                .register-logo {
                    margin-bottom: 20px;
                    display: inline-block;
                    animation: scaleIn 0.5s ease-out 0.2s both;
                }
                
                .register-title {
                    font-size: 28px;
                    font-weight: 700;
                    color: #F7FAFC;
                    margin: 0 0 8px 0;
                    animation: fadeIn 0.5s ease-out 0.3s both;
                }
                
                .register-subtitle {
                    font-size: 15px;
                    color: #A0AEC0;
                    margin: 0;
                    animation: fadeIn 0.5s ease-out 0.4s both;
                }
                
                .register-form {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    animation: fadeIn 0.5s ease-out 0.5s both;
                }
                
                .register-message {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 14px 16px;
                    border-radius: 12px;
                    font-size: 14px;
                }
                
                .register-message.error {
                    background: rgba(239, 68, 68, 0.15);
                    border: 1px solid rgba(239, 68, 68, 0.3);
                    color: #F87171;
                    animation: shake 0.5s ease-out;
                }
                
                .register-message.success {
                    background: rgba(16, 185, 129, 0.15);
                    border: 1px solid rgba(16, 185, 129, 0.3);
                    color: #34D399;
                    animation: fadeIn 0.3s ease-out;
                }
                
                @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    20%, 60% { transform: translateX(-5px); }
                    40%, 80% { transform: translateX(5px); }
                }
                
                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }
                
                .form-group label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #A0AEC0;
                    margin: 0;
                }
                
                .input-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                }
                
                .input-icon {
                    position: absolute;
                    left: 14px;
                    color: #64748B;
                    display: flex;
                    align-items: center;
                    pointer-events: none;
                }
                
                .register-input {
                    width: 100%;
                    padding: 14px 14px 14px 46px;
                    background: rgba(36, 43, 61, 0.8);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 12px;
                    color: #F7FAFC;
                    font-size: 15px;
                    transition: all 0.2s ease;
                }
                
                .register-input::placeholder {
                    color: #64748B;
                }
                
                .register-input:focus {
                    border-color: #10B981;
                    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
                    outline: none;
                }
                
                .register-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    width: 100%;
                    padding: 16px;
                    background: linear-gradient(135deg, #10B981 0%, #059669 100%);
                    border: none;
                    border-radius: 12px;
                    color: #FFFFFF;
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    margin-top: 8px;
                    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
                }
                
                .register-button:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(16, 185, 129, 0.5);
                }
                
                .register-button:active:not(:disabled) {
                    transform: translateY(0);
                }
                
                .register-button:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }
                
                .register-spinner {
                    width: 22px;
                    height: 22px;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                    border-top-color: #FFFFFF;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                }
                
                .register-footer {
                    text-align: center;
                    margin-top: 28px;
                    font-size: 14px;
                    color: #64748B;
                    animation: fadeIn 0.5s ease-out 0.6s both;
                }
                
                .register-link {
                    color: #10B981;
                    font-weight: 600;
                    text-decoration: none;
                    margin-left: 6px;
                    transition: color 0.2s ease;
                }
                
                .register-link:hover {
                    color: #34D399;
                }
                
                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                
                @keyframes scaleIn {
                    from {
                        opacity: 0;
                        transform: scale(0.8);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1);
                    }
                }
                
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default RegisterPage;

